
import { PromptCard } from "../../components/PromptCard";
import { Challenge as ChallengeType, Prompt } from "../../lib/types";

type Props = {
  challenge: ChallengeType;
  promptVotes: { [promptId: string]: number };
  votedPromptId: string | null;
  onVote: (promptId: string) => void;
};

export function PromptVotingSection({ challenge, promptVotes, votedPromptId, onVote }: Props) {
  return (
    <section className="space-y-4 mb-4">
      <h2 className="text-2xl font-bold text-bauhaus-darkgreen font-['Bebas_Neue'] tracking-wide mb-2">
        Choose a Prompt
      </h2>
      {challenge.promptOptions.map((prompt) => (
        <PromptCard
          key={prompt.id}
          prompt={{
            ...prompt,
            votes: promptVotes[prompt.id] ?? prompt.votes
          }}
          isVoted={votedPromptId === prompt.id}
          onVote={onVote}
        />
      ))}
    </section>
  );
}
